<form [formGroup]="form" (ngSubmit)="ok()">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Send test mail</h4>
  </div>
  <div class="form-group modal-body">

    <div class="form-group">
      <div class="control">
        <label>To</label>
        <input class="form-control" [class.invalid-state-border]="fcTo.invalid" type="text" formControlName="to"
          class="form-control" ngbAutofocus />
          <div [class.invisible]="fcTo.valid || (fcTo.pristine && fcTo.untouched)">
            <span>
              @if (fcTo.errors?.required) {
                <span class="error">Required</span>
              }
              @if (fcTo.errors?.email) {
                <span class="error">Not a valid email address</span>
              }
              &nbsp;
            </span>
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Send</button>
      <button type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
    </div>
  </form>
